'use client';
import { JsonView, collapseAllNested, darkStyles as _darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

export default function JSONViewer({data}: {data: object}) {
    return <JsonView data={data} style={defaultStyles} shouldExpandNode={collapseAllNested} />
}